import { IInitialState } from 'store/models';

export const mapSelector = (state: IInitialState) => state.admin.results.map;
export const isLoadingSelector = (state: IInitialState) =>
	mapSelector(state).isLoading;
export const zoomTypeIndexSelector = (state: IInitialState) =>
	mapSelector(state).zoomTypeIndex;
export const matchedLocationsSelector = (state: IInitialState) =>
	mapSelector(state).matchedLocations;
export const isLocationSearchForOfficeSelector = (state: IInitialState) =>
	mapSelector(state).isLocationSearchForOffice;
export const isLocationChangedSelector = (state: IInitialState) =>
	mapSelector(state).isLocationChanged;
